import { useCallback } from "react";
import {
  getRemarksAccess,
  getTimeEntryAccess,
  getMeterReadingAccess,
  getInspectionAccess,
  getCCAAccess,
  getStatusChangeAccess,
  getIssueFromTechAccess,
  getReturnFromTechAccess,
} from "../util/UserHelper";
import { useWorkOrderStore } from "../store/wo-order";

export default function useLoadCompWizardSections() {
  const setPermissions = useWorkOrderStore(
    (state) => state.setWoActionsPermissions
  );
  const loadCompWizardSections = useCallback(
    async (woNumber: string) => {
      const enabledItems = {
        Comment: false,
        TimeEntry: false,
        Meter: false,
        Inspections: false,
        CCA: false,
        IssueMaterial: false,
        ReturnMaterial: false,
        status: false,
      };
      enabledItems.Comment = await getRemarksAccess();
      enabledItems.TimeEntry = await getTimeEntryAccess();
      enabledItems.Meter = await getMeterReadingAccess();
      enabledItems.Inspections = await getInspectionAccess();
      enabledItems.CCA = await getCCAAccess();
      enabledItems.status = await getStatusChangeAccess();
      enabledItems.IssueMaterial = await getIssueFromTechAccess();
      enabledItems.ReturnMaterial = await getReturnFromTechAccess();

      setPermissions(woNumber, enabledItems);
    },
    [setPermissions]
  );

  return { loadCompWizardSections };
}
